// extracted by mini-css-extract-plugin
module.exports = {"root":"Toolbar_root__VDAK8","tools":"Toolbar_tools__3dw6L","closeBtn":"Toolbar_closeBtn__1stQw","blockWrapper":"Toolbar_blockWrapper__3l4g9","divider":"Toolbar_divider__1kRSx"};